import { render, staticRenderFns } from "./KusDocumentMetadata.vue?vue&type=template&id=486b9594"
import script from "./KusDocumentMetadata.vue?vue&type=script&lang=js"
export * from "./KusDocumentMetadata.vue?vue&type=script&lang=js"
import style0 from "./KusDocumentMetadata.vue?vue&type=style&index=0&id=486b9594&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports